<template>
  <div class="journal-article">
    <div class="article-scroll">
<!--      <header class="article-header">-->
<!--        <h1 class="header-title">-->
<!--          <img class="header-title-icon" src="@/assets/images/title.svg" alt="" />-->
<!--          {{ articleDetail.title }}-->
<!--        </h1>-->
<!--      </header>-->
      <main class="article-body">
        <div v-if="articleDetail.content" v-html="articleDetail.content" />
      </main>
    </div>
    <div class="footer-cta">
      <button class="origin-link-btn" type="button" @click="openOriginLink">
        点击查看原文链接
      </button>
      <div v-if="articleDetail.licenseUrl" class="origin-url">{{ articleDetail.licenseUrl }}</div>
      <div class="copyright-tip">*版权问题暂不提供直接下载，如有学术交流需要，请联系内部人员</div>
    </div>
  </div>
</template>

<script>
import withRouteTracking from '@/utils/withRouteTracking'
import { getProxyMobileDetails } from '@/api/article.js'
import {handleTraceFunction} from '@/utils/trace'
import {getShareInfo} from '../../utils/wxShare'
const UserProfile = {
  name: 'JournalArticle',
  data() {
    return {
      articleDetail: {
        title: '',
        licenseUrl: '',
        content: ''
      }
    }
  },
  mounted() {
    this.loadDetail()
  },
  methods: {
    getArticleId() {
      return this.$route.query.articleId || this.$route.query.id || ''
    },
    async loadDetail() {
      const id = this.getArticleId()
      if (!id) return
      try {
        const res = await getProxyMobileDetails(id)
        if (res.code === 0 && res.data) {
          window.sessionStorage.setItem('serviceId', id)
          window.sessionStorage.setItem('mainId', id)
          this.articleDetail = {
            title: res.data.title || '',
            licenseUrl: res.data.licenseUrl || '',
            content: res.data.content || ''
          }
          getShareInfo({
            title: res.data.title,
            titleTimeLine: res.data.title,
            desc: ``,
            link: window.location.href, // modifyURLParam(window.location.href, 'entrance', '20'),
            linkTimeLine: window.location.href, // modifyURLParam(window.location.href, 'entrance', '21'),
            images: res.data.icon || `https://iep.jjmc.cn/bw/file/material/image/1933146816339349528.jpg`,
          })
        }
      } catch (error) {
        void error
      }
    },
    async openOriginLink() {
      if (!this.articleDetail.licenseUrl) {
        this.$toast && this.$toast('暂无原文链接')
        return
      }
      try {
        if (this.$tipsDialog && this.$tipsDialog.confirm) {
          await this.$tipsDialog.confirm({
            title: '温馨提示',
            message: '您点击确认按键后，页面将跳转到第三方网站，该网站内容不受强生控制和影响，强生也不对其承担任何责任',
            cancelButtonText: '取消',
            confirmButtonText: '确认',
            showCloseIcon: false,
            messageStyle: { textAlign: 'center' }
          })
        }
        handleTraceFunction({
          functionName: `${this.getArticleId()}-期刊文章-原文链接确认`,
          functionUrl: this.articleDetail.licenseUrl,
          createTime: new Date().getTime(),
          entrance: this.$route.query.entrance || null,
          serviceId: this.getArticleId(),
        })
        window.location.href = this.articleDetail.licenseUrl
      } catch (error) {
        void error
      }
    }
  }
}
export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.journal-article {
  width: 100%;
  height: 100vh;
  background: #fff;
  position: relative;
  overflow: hidden;
  font-family: PingFang SC, PingFang HK, Helvetica Neue, Arial, sans-serif;

  .article-scroll {
    height: 100%;
    overflow-y: auto;
    box-sizing: border-box;
    padding: 18px 18px calc(120px + env(safe-area-inset-bottom));
  }

  .article-header {
    margin-bottom: 14px;
  }

  .header-title {
    display: block;
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    color: #222528;
    word-break: break-all;
    white-space: normal;
  }

  .header-title-icon {
    display: inline-block;
    width: 17px;
    height: 18px;
    margin: 1px 1px 1px 0;
    vertical-align: top;
  }

  .footer-cta {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    padding: 8px 12px calc(8px + env(safe-area-inset-bottom));
    box-sizing: border-box;
  }

  .origin-url {
    margin-top: 6px;
    font-size: 12px;
    color: #979797;
    text-decoration: underline;
    text-align: center;
    width: 270px;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 20px;
  }

  .copyright-tip {
    margin-top: 4px;
    font-size: 10px;
    text-align: center;
    color: #979797;
    letter-spacing: -1.5%;
    height: 20px;
  }

  .origin-link-btn {
    width: 100%;
    height: 54px;
    border: none;
    border-radius: 54px;
    background: #EB1700;
    color: #fff;
    font-size: 16px;
    line-height: 54px;
    font-weight: 500;
    letter-spacing: 0.5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/article/journalArticle.vue